<template>
    <div>
        <van-nav-bar title="投票大厅" fixed left-arrow @click-left="onClickLeft" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" size="22" color="#333" />
            </template>
        </van-nav-bar>
        <div class="content">
            <div class="banner-swiper">
                <div class="swiper">
                    <van-swipe autoplay="5000" loop>
                        <van-swipe-item v-for="item in bannerList" :key="item.id">
                            <img style="width:100%;height:100%;object-fit: cover;" :src="$baseURL + item.url" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="notice-box">
                <div class="notice-content">
                    <van-swipe style="height: 88px;" @change="scrollNoticeActiveChange" autoplay="3000"
                        :touchable="false" :show-indicators="false" vertical loop>
                        <van-swipe-item>
                            <div class="notice">{{ scrollNotice1 }}</div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="notice">{{ scrollNotice2 }}</div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="lotteryBox">
                <div class="lotteryHallgrid">
                    <div class="item">
                        <div class="weui-grids" link="">
                            <a href="javascript:;" @click="go2Lottery" class="weui-grid listItem"
                                style="width: 50%;">
                                <div><img src="/img/renzheng.png" alt="">
                                </div>
                                <div class="name">认证窗口</div>
                                <van-count-down class="count_down" style="color: rgb(172, 98, 204);" format="HH:mm:ss" :time="time" @finish="getLotteryInfo()" />
                            </a> 
                            <a href="javascript:;" @click="go2discuss" class="weui-grid listItem" style="width: 50%;">
                                <div><img src="/img/icon1.png" alt=""></div>
                                <div class="name">真实客户反馈</div>
                                <div class="h"></div>
                            </a></div>
                    </div>
                </div>
            </div>
            <div><img src="/img/2.3fac88b.png" alt="" class="gameindexbg"></div>
        </div>
    </div>
</template>
<script>
import utils from '@/pages/home/utils'
export default {
    data() {
        return {
            bannerList: [],
            goodsList: [],
            scrollNotice1: '',
            scrollNotice2: '',
            scrollNoticeActive: 0,
            time:0,
        }
    },
    created() {
        this.getBannerList()
        this.getGoods()
    },
    methods: {
        getLotteryInfo() {
            this.$http({
                method: "get",
                data: { key: 5 },
                url: "lottery_get_info",
            }).then((res) => {
                if (res.code === 200) {
                    this.time = res.data.second * 1000;
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            });
        },
        go2discuss(){
            this.$router.push('/discuss')
        },
        go2Lottery(){
            this.$router.push('/Lottery')
        },
        scrollNoticeActiveChange(index) {
            this.scrollNoticeActive = index
            this.changeScrollNotice()
        },
        changeScrollNotice() {
            if (this.goodsList.length == 0) {
                return false;
            }
            if (!this.scrollNotice1) {
                this.scrollNotice1 = utils.generateNotice(this.goodsList)
                this.scrollNotice2 = utils.generateNotice(this.goodsList)
            }
            if (this.scrollNoticeActive == 0) {
                this.scrollNotice2 = utils.generateNotice(this.goodsList)
            } else {
                this.scrollNotice1 = utils.generateNotice(this.goodsList)
            }
        },
        getGoods() {
            this.$http({
                method: "get",
                url: "goods",
            }).then((res) => {
                this.goodsList = res.data
                this.changeScrollNotice()
            });
        },
        getBannerList() {
            this.$http({
                method: "get",
                url: "getBannerList",
            }).then((res) => {
                this.bannerList = res.data
            });
        },
        onClickLeft() {
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .van-tabs__nav {
    background: initial;
}

/deep/ .van-nav-bar__title {
    color: #333 !important;
}

.van-nav-bar {
    background: white;
    border-bottom-width: 0;
}

.content {
    padding: 120px 0;
    background: #f2f2f2;
}

.banner-swiper {
    padding: 4px 20px;
    /* 0.125×32=4, 0.625×32=20 */
    background: #f2f2f2;

    .swiper {
        padding: 4px 0 !important;
        /* 0.125×32=4 */
        background: #f2f2f2;
        border-radius: 36px;
        /* 1.125×32=36 */
        box-shadow: 0 4px 2px #655c4b;
        /* 0.125×32=4, 0.0625×32=2 */
        height: 300px;
        overflow: hidden;

        img {
            height: 300px !important;
        }
    }
}

.notice-box {
    padding: 20px 0;

    .notice-content {
        margin: 0 0.625rem;
        background: #fff6f8;
        border-radius: 0.5rem;
        border: 0.0625rem solid #ffd5db;
        box-shadow: 0 0.125rem 0.5rem rgba(255, 77, 103, 0.08);
        display: flex;
        align-items: flex-start;
        position: relative;
        overflow: hidden;
    }

    .notice {
        width: 100%;
        display: flex;
        align-items: center;
        color: #ff4d67;
        font-size: 1.1rem;
        font-family: PingFang SC, Arial, sans-serif;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-all;
        padding: 0.375rem 1.125rem;
        letter-spacing: 0.03125rem;
        line-height: 1.5;
        box-sizing: border-box;
        background: transparent;
    }
}

.lotteryBox {
    .lotteryHallgrid {
        text-align: center;

        .weui-grids {
            position: relative;
            overflow: hidden;

            &:before {
                content: " ";
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                height: 1px;
                border-top: 1px solid #D9D9D9;
                color: #D9D9D9;
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;
                -webkit-transform: scaleY(0.5);
                transform: scaleY(0.5);
            }

            &:after {
                content: " ";
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                height: 1px;
                border-bottom: 1px solid #D9D9D9;
                color: #D9D9D9;
                -webkit-transform-origin: 0 100%;
                transform-origin: 0 100%;
                -webkit-transform: scaleY(0.5);
                transform: scaleY(0.5);
                margin-bottom: 1px;
            }

            a {
                background: #fff;
            }

            .weui-grid {
                position: relative;
                float: left;
                padding: 20px 10px;
                width: 33.33333333%;
                box-sizing: border-box;
                padding: 10px 10px;
                color: #000;
                display: flex;
                flex-direction: column;
                justify-content: center;

                &:before {
                    content: " ";
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    bottom: 0;
                    border-right: 1px solid #D9D9D9;
                    color: #D9D9D9;
                    -webkit-transform-origin: 100% 0;
                    transform-origin: 100% 0;
                    -webkit-transform: scaleX(0.5);
                    transform: scaleX(0.5);
                    margin-right: 1px;
                }

                img {
                    width: 112px;
                    height: 112px;
                    border-radius: 50%;
                    display: inline-block;
                }

                .count_down {
                    line-height: 40px;
                    color: #ff4d67;
                    font-size: 26px;
                    line-height: 50px;
                    border-width: 0;
                    padding: 0;
                    border-radius: 0;
                    margin-top: 4px;
                    float: inherit;

                    .periods_time {
                        font-size: 26px;
                        color: #ff4d67;
                    }
                }

                .h {
                    height: 1.6rem;
                }
            }
        }
    }
}

.gameindexbg {
    margin-top: 20px;
    width: 100%;
}
</style>